import apiProduct from "@/api/seller/product";
import apiB2b from "@/api/seller/B2b";

const defaultState = () => ({
  productData: [],
  productInternalData: [],
  loadProduct: false,
  detailProduct: {},
  productPagination: "",
  response: {
    code: "",
    message: ""
  },
  responseError: {},
  alertMultiple: [],
  alert: ""
});

const state = defaultState();

const getters = {};

const mutations = {
  setProduct(state, data) {
    state.productData = data.data;
    state.productPagination = data.pagination;
  },
  setProductInternal(state, data) {
    state.productInternalData = data.data;
    state.productPagination = data.pagination;
  },
  setloadProduct(state, data) {
    state.loadProduct = data;
  },
  setProductDetail(state, data) {
    state.detailProduct = data;
  },
  saveResponse(state, data) {
    state.response = data;
    state.alertMultiple = [];
    state.responseError = {};
    state.alert = "";
  },
  validationError(state, data) {
    state.responseError = data;
  },
  multipleAlert(state, data) {
    state.alertMultiple = data.map(el => {
      return {
        show: true,
        message: el
      };
    });
  },
  failed(state, data) {
    state.alert = data;
  },
  clearProduct(state) {
    Object.assign(state, defaultState());
  }
};

const actions = {
  getProduct({ commit }, params) {
    commit("setloadProduct", true);
    return new Promise(resolve => {
      apiProduct
        .getProduct(params)
        .then(({ data: { data } }) => {
          commit("setProduct", { data: data.results, pagination: data.pagination });
          resolve(true);
        })
        .catch(() => {
          commit("setProduct", { data: [], pagination: {} });
        })
        .then(() => {
          commit("setloadProduct", false);
        });
    });
  },
  getProductInternal({ commit }, params) {
    commit("setloadProduct", true);
    return new Promise(resolve => {
      apiProduct
        .getProductInternal(params)
        .then(({ data: { data } }) => {
          commit("setProductInternal", { data: data.results, pagination: data.pagination });
          resolve(true);
        })
        .catch(() => {
          commit("setProductInternal", { data: [], pagination: {} });
        })
        .then(() => {
          commit("setloadProduct", false);
        });
    });
  },
  getProductDetail({ commit }, params) {
    commit("setloadProduct", true);
    return new Promise((resolve, reject) => {
      apiProduct
        .getProductDetail(params)
        .then(({ data: { data } }) => {
          commit("setProductDetail", data.results);
          resolve(true);
        })
        .catch(err => {
          const { data } = err.response;
          commit(
            "makeAlert",
            { code: "error_response", type: "error", message: data.message, show: true },
            { root: true }
          );
          commit("setProductDetail", {});
          reject(true);
        })
        .then(() => {
          commit("setloadProduct", false);
        });
    });
  },
  addProduct({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      apiProduct
        .addProduct(params)
        .then(({ data }) => {
          dispatch("success", data);
          resolve(data.message);
        })
        .catch(err => {
          const { data } = err.response;
          dispatch("errorHandler", data);
          reject(true);
        });
    });
  },
  updateProduct({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      apiProduct
        .updateProduct(params)
        .then(({ data }) => {
          dispatch("success", data);
          resolve(true);
        })
        .catch(err => {
          const { data } = err.response;
          dispatch("errorHandler", data);
          reject(true);
        });
    });
  },
  addProductB2b({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      apiB2b
        .addProductB2b(params)
        .then(({ data }) => {
          dispatch("success", data);
          resolve(data.message);
        })
        .catch(err => {
          const { data } = err.response;
          dispatch("errorHandler", data);
          reject(true);
        });
    });
  },
  updateProductB2b({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      apiB2b
        .updateProductB2b(params)
        .then(({ data }) => {
          dispatch("success", data);
          resolve(true);
        })
        .catch(err => {
          const { data } = err.response;
          dispatch("errorHandler", data);
          reject(true);
        });
    });
  },
  statusProduct({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      apiProduct
        .statusProduct(params)
        .then(({ data }) => {
          dispatch("success", data);
          resolve(true);
        })
        .catch(err => {
          const { data } = err.response;
          dispatch("errorHandler", data);
          reject(true);
        });
    });
  },
  removeProduct({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      apiProduct
        .removeProduct(params)
        .then(({ data }) => {
          dispatch("success", data);
          resolve(true);
        })
        .catch(err => {
          const { data } = err.response;
          dispatch("errorHandler", data);
          reject(true);
        });
    });
  },
  uploadImage({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      apiProduct
        .uploadImage(params)
        .then(({ data: { data } }) => {
          resolve(data.results);
        })
        .catch(err => {
          const { data } = err.response;
          dispatch("errorHandler", data);
          reject(true);
        });
    });
  },
  uploadImageV2({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      apiProduct
        .uploadImageV2(params)
        .then(({ data: { data } }) => {
          resolve(data.results);
        })
        .catch(err => {
          const { data } = err.response;
          dispatch("errorHandler", data);
          reject(true);
        });
    });
  },
  removeProductImage({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      apiProduct
        .removeProductImage(params)
        .then(({ data }) => {
          dispatch("success", data);
          resolve(true);
        })
        .catch(err => {
          const { data } = err.response;
          dispatch("errorHandler", data);
          reject(true);
        });
    });
  },
  async success({ commit }, response) {
    await commit("saveResponse", response);
    await commit(
      "makeAlert",
      { code: "success", type: "success", message: response.message, show: true },
      { root: true }
    );
  },
  errorHandler({ commit }, response) {
    switch (response.message) {
      case "error_validation":
        commit("validationError", response.data);
        break;

      case "error_multiple_alert":
        commit("multipleAlert", response.data.error);
        break;

      default:
        commit(
          "makeAlert",
          { code: "error_response", type: "error", message: response.message, show: true },
          { root: true }
        );
        break;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
